import { memo } from 'react';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { Button } from 'root/src/client/v2/common/components/ui/button';
// Redesign replacement for the legacy `GetVerifiedModal` (shown on `VerificationPending`). Shown
// non-closeable (no overlay / escape dismiss); the only exit is the OK button.
export const RedesignVerificationPendingModal = memo(() => {
    const modal = useRedesignModal();
    return (<RedesignModalShell className="sm:max-w-md">
			<div className="flex w-full flex-col items-center gap-3 text-center">
				<div className="flex h-14 w-14 items-center justify-center rounded-full border border-solid border-neon-cyan/30 bg-neon-cyan/10">
					<VerifiedUserOutlinedIcon sx={{ fontSize: 28 }} className="text-neon-cyan"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">Let&apos;s get verified</h2>
				<p className="text-sm text-muted-foreground">
					Since this is your first time using Dare Drop, our team is reviewing your account to approve you.
				</p>
			</div>

			<p className="w-full text-center text-sm text-muted-foreground">
				Once approved, you&apos;ll get an email alert and be able to participate in Drops without waiting.
			</p>

			<p className="w-full text-center text-xs font-semibold text-neon-cyan">
				The verification process takes less than a day on weekdays.
			</p>

			<Button variant="brand" onClick={modal.hide} className="w-full max-w-xs rounded-lg text-sm font-semibold">
				OK
			</Button>
		</RedesignModalShell>);
});
